const MediaSubCategoryType = Object.freeze({
  DEFAULT: "DEFAULT",
  DETAIL: "DETAIL",
  ASSIGNMENT: "ASSIGNMENT"
});
export default MediaSubCategoryType;